export default __webpack_public_path__ + "static/logo-inverted-ab06d76a05e1de77d712795e642e843a.png";